import React, { ReactNode } from "react";
import styles from "./style.scss";
import cn from "classnames";
import CloseIcon from "images/icon/Path.svg";

interface Props {
  children: ReactNode;
  error?: boolean;
  onClick?: () => void;
}

const NotificationToast: React.FunctionComponent<Props> = ({
  children,
  error = false,
  onClick
}) => {
  return (
    <div className={cn(styles.modal, { [styles.error]: error })}>
      <img className={styles.close} src={CloseIcon} onClick={onClick} />
      <div
        className={styles.content}
        data-testid="features-MailDownloadToast-content"
      >
        <div>{children}</div>
      </div>
    </div>
  );
};

export default NotificationToast;
